import { useEffect } from "react";
import { ColumnsType } from "antd/es/table";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { dateFormatter } from "project-config/utils/date-formatter";
import { useDynamicForm } from "@/components/dynamic-form/hook/useDynamicForm";
import { useModalFormStore } from "../../../store/modal-form-store";
import { enhanceEndTime } from "@/components/dynamic-form/formatter/enhanceEndTime";

export function useChangeLog() {
  const t = getTranslateNsT("profile");
  const { openUserChangeLogDrawer } = useModalFormStore();
  const columns: ColumnsType<any> = [
    {
      dataIndex: "changeType",
      title: t("user_change_type"),
      render: (changeType) => t(`user_change_type_${changeType}`),
    },
    { dataIndex: "beforeChangeMainstay", title: t("user_change_before") },
    { dataIndex: "afterChangeMainstay", title: t("user_change_after") },
    {
      dataIndex: "createDate",
      title: t("user_change_start_time"),
      render: (createDate) => dateFormatter(createDate),
    },
    {
      dataIndex: "changeStatus",
      title: t("user_change_status"),
      render: (changeStatus, row) => {
        if (!changeStatus) {
          return (
            <div>
              <span style={{ color: "red" }}>{t("user_change_status_0")}</span>
              &nbsp;
              <span>
                ,{t("user_change_fail_reason")}:{row.remarks}
              </span>
            </div>
          );
        }
        return t("user_change_status_1");
      },
    },
  ];
  const { tableData, fetchData } = useDynamicForm({
    api: "/api/rendering/user/getAuthChangeMainstayRecord",
    noPagination: true,
    formatter: {
      time: enhanceEndTime,
    },
  });
  useEffect(() => {
    if (!openUserChangeLogDrawer) return;
    fetchData().catch(console.trace);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openUserChangeLogDrawer]);

  return {
    columns,
    tableData,
    fetchData,
  };
}
